














import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";
import { Document } from "../Document.vue";

@Component({ components: { SimpleText } })
export default class DocumentInsertionSupport extends Vue {
    @Prop() public document!: Document;

    public static getNeededFields(): string[] {
        return [];
    }
}
